import getResponseJson from './getresponsejson';

const medicareDetailsService = serviceRoutes => {
  const init = (
    encounterId
  ) => {

    return fetch(`${serviceRoutes.init}?id=${encounterId}`, {
      credentials: 'include'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    })
    .catch(e => {
      console.error(e.toString());
    });
  };

  return {
    init,
    serviceRoutes
  };
};

export default medicareDetailsService;
